import { Chip, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import PropTypes from "prop-types";
import { useCallback, useEffect, useState } from "react";
import { get } from "utils/WebService";
import AnexosSolicitacao from "./AnexosSolicitacao";
import { EVENTO_SOLICITACOES_ALTERADAS, alvoSolicitacao, comAlfa, listaDe, tipoSolicitacao } from "./solicitacaoUtils";

const COR = {
    PENDENTE: { light: "#B26A00", dark: "#FFB74D", rotulo: "Na Fila de Solicitações" },
    REJEITADA: { light: "#C62828", dark: "#EF5350", rotulo: "Recusada · aguardando o solicitante" },
};

/**
 * Aviso no topo da ficha: solicitações de devolução/migração em aberto deste devedor. Quem pediu troca o anexo
 * errado, exclui ou adiciona por aqui enquanto a solicitação não é concluída.
 */
export default function SolicitacoesAbertasFicha({ recordId, isViewOnly = false }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const [lista, setLista] = useState([]);
    const [erro, setErro] = useState("");

    const carregar = useCallback(() => {
        if (!recordId) return;
        get(`/solicitacoes-suporte/abertas/devedor/${recordId}`)
            .then(res => setLista(listaDe(res)))
            .catch(() => setLista([]));
    }, [recordId]);

    useEffect(() => {
        carregar();
        window.addEventListener(EVENTO_SOLICITACOES_ALTERADAS, carregar);
        return () => window.removeEventListener(EVENTO_SOLICITACOES_ALTERADAS, carregar);
    }, [carregar]);

    if (lista.length === 0) return null;

    return (
        <MDBox px={2} mb={1.5} display="flex" flexDirection="column" gap={1}>
            {lista.map(s => {
                const tipo = tipoSolicitacao(s.tipoSolicitacao);
                const estilo = COR[s.status] || COR.PENDENTE;
                const cor = darkMode ? estilo.dark : estilo.light;
                return (
                    <MDBox key={s.id} p={1.5} borderRadius="md"
                        sx={{ background: comAlfa(cor, darkMode ? 0.16 : 0.07), borderLeft: `4px solid ${cor}` }}>
                        <MDBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
                            <Icon sx={{ color: cor }}>{tipo.icone}</Icon>
                            <MDTypography variant="button" fontWeight="bold" color="text">{tipo.label}</MDTypography>
                            <MDTypography variant="caption" color="text">· {alvoSolicitacao(s)}</MDTypography>
                            <Chip size="small" label={estilo.rotulo} variant="outlined"
                                sx={{ height: 20, fontSize: 11, borderColor: cor, color: `${cor} !important` }} />
                            <MDTypography variant="caption" color="text" sx={{ opacity: 0.85 }}>
                                pedida por {s.nomeSolicitante || "-"} em {s.dataSolicitacao}
                            </MDTypography>
                        </MDBox>
                        {s.status === "REJEITADA" && s.motivoRecusa && (
                            <MDTypography variant="caption" color="text" sx={{ display: "block", mt: 0.5 }}>
                                <strong>Motivo da recusa:</strong> {s.motivoRecusa}
                            </MDTypography>
                        )}
                        <MDBox mt={0.75}>
                            <AnexosSolicitacao
                                solicitacao={s}
                                somenteLeitura={isViewOnly}
                                onChange={(atualizada) => { setErro(""); setLista(l => l.map(x => (x.id === atualizada.id ? atualizada : x))); }}
                                onErro={setErro}
                            />
                        </MDBox>
                    </MDBox>
                );
            })}
            {erro && (
                <MDTypography variant="caption" color="error" fontWeight="bold">{erro}</MDTypography>
            )}
        </MDBox>
    );
}

SolicitacoesAbertasFicha.propTypes = {
    recordId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isViewOnly: PropTypes.bool,
};
